export default __webpack_public_path__ + "static/media/Maddy_Sherman.15f0e4fe.png";